import styled from 'styled-components';
import {
  FiCheckCircle,
  FiInfo,
  FiAlertTriangle,
  FiAlertCircle,
  FiX,
} from 'react-icons/fi';

export const SuccessIcon = styled(FiCheckCircle)`
  color: ${({ theme }) => theme.colors.white};
  margin-right: 0.75rem;
  width: 1.5rem;
  height: 1.5rem;
`;

export const InfoIcon = styled(FiInfo)`
  color: ${({ theme }) => theme.colors.white};
  margin-right: 0.75rem;
  width: 1.5rem;
  height: 1.5rem;
`;

export const WarningIcon = styled(FiAlertTriangle)`
  color: ${({ theme }) => theme.colors.white};
  margin-right: 0.75rem;
  width: 1.5rem;
  height: 1.5rem;
`;

export const ErrorIcon = styled(FiAlertCircle)`
  color: ${({ theme }) => theme.colors.white};
  margin-right: 0.75rem;
  width: 1.5rem;
  height: 1.5rem;
`;

export const CloseIcon = styled(FiX)`
  color: ${({ theme }) => theme.colors.white};
  margin-right: 1rem;
  width: 1rem;
  height: 1rem;
`;
